export default __webpack_public_path__ + "static/pancake-swap-0d3d9f4bc2afe3549dac3203d5b855ae.png";